import type { Favorite, FavoriteCreateInput, FavoriteList, FavoriteListCreateInput } from '~/models/Favorites'
import { externalClient } from '~/api/client/externalClient'

export const useFavoritesApi = () => ({
  getFavoriteLists: async (): Promise<FavoriteList[]> =>
    (await externalClient.get<FavoriteList[]>('/frontend/favorites')).data,

  getFavoriteList: async (listId: string): Promise<FavoriteList> =>
    (await externalClient.get<FavoriteList>(`/frontend/favorites/${listId}`)).data,

  updateFavoriteList: async (item: FavoriteList, signal?: AbortSignal): Promise<FavoriteList> =>
    (await externalClient.put<FavoriteList>(`/frontend/favorites/${item.id}`, item, { signal })).data,

  deleteFavoriteList: async (item: FavoriteList): Promise<void> =>
    await externalClient.delete(`/frontend/favorites/${item.id}`),

  createFavoriteList: async (item: FavoriteListCreateInput): Promise<FavoriteList> =>
    (await externalClient.post('/frontend/favorites', item)).data,

  createFavorite: async (item: FavoriteCreateInput, list: FavoriteList): Promise<Favorite> =>
    (await externalClient.post(`/frontend/favorites/${list.id}`, item)).data,

  getFavorite: async (favoriteId: string): Promise<Favorite> =>
    (await externalClient.get(`/frontend/favorite-item/${favoriteId}`)).data,

  updateFavorite: async (item: Favorite): Promise<Favorite> =>
    (await externalClient.put(`/frontend/favorite-item/${item.id}`, item)).data,

  removeFavoriteFromList: async ({ item, list }: { item: Favorite, list: FavoriteList }) =>
    await externalClient.delete(`/frontend/favorites/${list.id}/${item.id}`),
})
